export const isScrollable = (el) => {
    const { overflow, overflowX, overflowY } = window.getComputedStyle(el);
    return Boolean([overflow, overflowX, overflowY].find((style) => /(auto|scroll)/.test(style)));
};
//# sourceMappingURL=isScrollable.js.map